export function getOrganizationAndDeviceSettings() {
    if (window.__UpshowState && window.__UpshowState.settings) {
        const settings = window.__UpshowState.settings;

        return {
            organization: settings.organization && {
                id: settings.organization.id
            },
            topOrganizationId: settings.top_organization_id,
            topOrganizationName: settings.top_organization_name
        };
    }

    return null;
}

export function getPendoInstance() {
    return window.pendo;
}

export function parsePendoSettings(orgSettings) {
    if (!orgSettings || !orgSettings.organization) {
        return null;
    }

    return {
        visitor: {
            id: orgSettings.organization.id,
            session_type: "On screen menu session",
        },
        account: {
            id: orgSettings.topOrganizationId,
            organization_name: orgSettings.topOrganizationName,
        }
    };
}

export function initializePendo(orgSettings) {
    const pendo = getPendoInstance();
    const pendoSettings = parsePendoSettings(orgSettings);

    if (!pendoSettings || !pendo) {
        return;
    }

    if (pendo && pendo.isReady && typeof pendo.isReady === "function") {
        if (pendo.isReady()) pendo.identify(pendoSettings);
        else pendo.initialize(pendoSettings);
    }
}

export function trackPendoEvent(eventLabel, eventPayload = null) {
    if (!eventLabel) {
        return;
    }
    const pendo = getPendoInstance();
    if (!pendo) {
        return;
    }
    try {
        pendo.track(eventLabel, {
            ...eventPayload,
        });
    } catch (error) {
        console.error("Event not tracked due to error: ", error);
    }
}
